// removed by extract-text-webpack-plugin
module.exports = {"oy_chekcbox":"oy_chekcbox__1UJ5GJo8","body":"body__2CtciP-H","tr":"tr__2CjlfvaH","td":"td__1yViKVHe","oy_chekcbox_splitIndeterminate":"oy_chekcbox_splitIndeterminate__QDVJYQIB","indeterminate":"indeterminate__2_lLLrJ2","checked":"checked__3_PhSE9r","oy_chekcbox_td":"oy_chekcbox_td__1_0PunUn","oy_chekcbox_tdWrapper":"oy_chekcbox_tdWrapper__2WA09H2X","oy_chekcbox_item":"oy_chekcbox_item__3F6VeZSx","hideBox":"hideBox__37Aqn_i9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYCheckbox2/index.module.less
// module id = 759
// module chunks = 1